// extracted by mini-css-extract-plugin
module.exports = {"video-section":"k_t d-flex","video-section--header":"k_v","video-section__frame":"k_w ml-3"};